module.exports = __webpack_public_path__ + "img/eggstravaganza.8988fde8.png";